/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Dash from './views/Dash.vue'
import Login from './views/Login/Login.vue'

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
      meta: { title: 'Login' }
    },
    {
      path: '/home',
      name: 'home',
      component: Dash,
      meta: { title: 'Painel' },
      children: [
        // CADASTRO
        {
          path: '/home',
          name: 'Home',
          meta: { title: 'Home' },
          component: () => import('./views/Home/Home.vue')
        },
        {
          path: '/produtos',
          name: 'Produtos',
          meta: { title: 'Produtos' },
          component: () => import('./views/Cadastros/produto/Produtos.vue')
        },
        {
          path: '/produtos/cadastrar',
          name: 'ProdutosCadastrar',
          meta: { title: 'Cadastrar Produto' },
          component: () => import('./views/Cadastros/produto/CadastrarProdutos.vue')
        },
        {
          path: '/grupos',
          name: 'Grupos',
          meta: { title: 'Grupos' },
          component: () => import('./views/Cadastros/grupos/Grupos.vue')
        },
        {
          path: '/marcas',
          name: 'Marcas',
          meta: { title: 'Marcas' },
          component: () => import('./views/Cadastros/marcas/Marcas.vue')
        },
        {
          path: '/participantes',
          name: 'Participantes',
          meta: { title: 'Participantes' },
          component: () => import('./views/Cadastros/participante/Participante.vue')
        },
        {
          path: '/participante/cadastrar',
          name: 'ParticipanteCadastrar',
          meta: { title: 'Cadastrar Participante' },
          component: () => import('./views/Cadastros/participante/CadastrarParticipante.vue')
        },
        {
          path: '/operadora-cartao',
          name: 'FormaPagamento',
          meta: { title: 'Forma de Pagamento' },
          component: () => import('./views/Cadastros/forma_pagamento/FormaPagamento.vue')
        },
        {
          path: '/operadora-cartao/cadastrar',
          name: 'FormaPagamentoCadastrar',
          meta: { title: 'Cadastrar Forma de Pagamento' },
          component: () => import('./views/Cadastros/forma_pagamento/CadastrarFormaPagamento.vue')
        },
        {
          path: '/empresa',
          name: 'Empresa',
          meta: { title: 'Empresas' },
          component: () => import('./views/Cadastros/empresas/Empresa.vue')
        },
        {
          path: '/empresa/cadastrar',
          name: 'EmpresaCadastrar',
          meta: { title: 'Cadastrar Empresa' },
          component: () => import('./views/Cadastros/empresas/EmpresaCadastro.vue')
        },
        {
          path: '/funcionario',
          name: 'Funcionario',
          meta: { title: 'Funcionários' },
          component: () => import('./views/Cadastros/funcionario/Funcionario.vue')
        },
        {
          path: '/funcionario/cadastrar',
          name: 'FuncionarioCadastrar',
          meta: { title: 'Cadastrar Funcionário' },
          component: () => import('./views/Cadastros/funcionario/CadastrarFuncionario.vue')
        },
        {
          path: '/veiculo',
          name: 'Veiculo',
          meta: { title: 'Veículos' },
          component: () => import('./views/Cadastros/veiculo/Veiculo.vue')
        },
        {
          path: '/cfops',
          name: 'CFOPs',
          meta: { title: 'CFOPs' },
          component: () => import('./views/Cadastros/cfop/cfop.vue')
        },
        {
          path: '/cst-csosn',
          name: 'CSTCSOSN',
          meta: { title: 'CST/CSOSN' },
          component: () => import('./views/Cadastros/cst/cst.vue')
        },
        {
          path: '/evento-caixa',
          name: 'EventoCaixa',
          meta: { title: 'Eventos de Caixa' },
          component: () => import('./views/Cadastros/eventos_caixa/EventoCaixa.vue')
        },
        {
          path: '/evento-administrativo',
          name: 'EventoAdministativo',
          meta: { title: 'Eventos Administrativos' },
          component: () => import('./views/Cadastros/eventos_administrativo/EventoAdministrativo.vue')
        },
        {
          path: '/plano-contas',
          name: 'PlanoContas',
          meta: { title: 'Plano de Contas' },
          component: () => import('./views/Cadastros/plano_contas/PlanoContas.vue')
        },
        // CONSULTAS
        {
          path: '/historico-cliente',
          name: 'HistoricoCliente',
          meta: { title: 'Histórico Cliente' },
          component: () => import('./views/Consultas/historico_cliente/HistoricoCliente.vue')
        },
        {
          path: '/historico-produto',
          name: 'HistoricoProduto',
          meta: { title: 'Histórico Produto' },
          component: () => import('./views/Consultas/historico_produto/HistoricoProduto.vue')
        },
        // MOVIMENTAÇÕES
        {
          path: '/dfe',
          name: 'Dfe',
          meta: { title: 'DFE' },
          component: () => import('./views/Movimentacao/dfe/DFe.vue')
        },
        {
          path: '/notas',
          name: 'NotaFiscalPropria',
          meta: { title: 'Notas Fiscais Próprias' },
          component: () => import('./views/Movimentacao/nota_fiscal_propria/NotaFiscalPropria.vue')
        },
        {
          path: '/notas/cadastrar',
          name: 'NotaFiscalPropriaCadastrar',
          meta: { title: 'Cadastrar Nota Fiscal Própria' },
          component: () => import('./views/Movimentacao/nota_fiscal_propria/NotaFiscalPropriaCadastrar.vue')
        },
        {
          path: '/notas-entrada',
          name: 'Notasentrada',
          meta: { title: 'Notas Fiscais de Entrada' },
          component: () => import('./views/Movimentacao/notas_entrada/NotasEntrada.vue')
        },
        {
          path: '/notas-entrada/cadastrar',
          name: 'NotasEntradaCadastrar',
          meta: { title: 'Cadastrar Nota de Entrada' },
          component: () => import('./views/Movimentacao/notas_entrada/NotasEntradaCadastrar.vue')
        },
        {
          path: '/carta_correcao',
          name: 'CartaCorrecao',
          meta: { title: 'Carta de Correção' },
          component: () => import('./views/Movimentacao/carta_correcao/CartaCorrecao.vue')
        },
        {
          path: '/frete',
          name: 'Frete',
          meta: { title: 'Frete' },
          component: () => import('./views/Movimentacao/frete/Frete.vue')
        },
        {
          path: '/frete_cadastrar',
          name: 'FreteCadastrar',
          meta: { title: 'Cadastrar Frete' },
          component: () => import('./views/Movimentacao/frete/FreteCadastrar.vue')
        },
        {
          path: '/lancamento-caixa',
          name: 'LancamentoCaixa',
          meta: { title: 'Lançamento de Caixa' },
          component: () => import('./views/Movimentacao/lancamento_caixa/LancamentoCaixa.vue')
        },
        {
          path: '/lancamento-caixa/cadastrar',
          name: 'LancamentoCaixaCadastrar',
          meta: { title: 'Cadastrar Lançamento de Caixa' },
          component: () => import('./views/Movimentacao/lancamento_caixa/LancamentoCaixaCadastrar.vue')
        },
        {
          path: '/mov-evento-admin',
          name: 'MovEventoAdministativo',
          meta: { title: 'Mov. Eventos Administrativos' },
          component: () => import('./views/Movimentacao/mov_administrativo/MovEventoAdmin.vue')
        },
        {
          path: '/mov-evento-admin/cadastrar',
          name: 'MovEventoAdministativoCadastrar',
          meta: { title: 'Cadastrar Mov. Evento Administrativo' },
          component: () => import('./views/Movimentacao/mov_administrativo/MovEventoAdminCadastrar.vue')
        },
        {
          path: '/requisicao',
          name: 'Requisicao',
          meta: { title: 'Requisições' },
          component: () => import('./views/Movimentacao/requisicao/Requisicao.vue')
        },
        {
          path: '/requisicao/cadastro',
          name: 'RequisicaoCadastro',
          meta: { title: 'Cadastrar Requisição' },
          component: () => import('./views/Movimentacao/requisicao/RequisicaoCadastro.vue')
        },

        // CONTROLES
        {
          path: '/conta-receber',
          name: 'ContaReceber',
          meta: { title: 'Contas a Receber' },
          component: () => import('./views/Controle/conta_receber/ContaReceber.vue')
        },
        {
          path: '/conta-pagar',
          name: 'ContaPagar',
          meta: { title: 'Contas a Pagar' },
          component: () => import('./views/Controle/conta_pagar/ContaPagar.vue')
        },
        {
          path: '/controle-entrega',
          name: 'ControleEntrega',
          meta: { title: 'Controle de Entrega - Pedidos' },
          component: () => import('./views/Controle/controle_entrega/ControleEntrega.vue')
        },
        {
          path: '/controle-entrega/itens',
          name: 'ControleEntregaItens',
          meta: { title: 'Controle de Entrega - Itens' },
          component: () => import('./views/Controle/controle_entrega/ControleEntregaItens.vue')
        },
        {
          path: '/romaneio',
          name: 'Romaneio',
          meta: { title: 'Romaneio' },
          component: () => import('./views/Controle/romaneio/Romaneio.vue')
        },
        {
          path: '/romaneio/cadastrar',
          name: 'RomaneioCadastrar',
          meta: { title: 'Cadastrar Romaneio' },
          component: () => import('./views/Controle/romaneio/RomaneioCadastrar.vue')
        },
        // CONFIGURAÇÕES
        {
          path: '/parametro',
          name: 'Parmetro',
          meta: { title: 'Parâmetros' },
          component: () => import('./views/Configuracoes/parametros/Parametros.vue')
        },
        {
          path: '/auditoria',
          name: 'Auditoria',
          meta: { title: 'Auditoria' },
          component: () => import('./views/Outros/auditoria/Auditoria.vue')
        },
        {
          path: '/sobre',
          name: 'Sobre',
          meta: { title: 'Sobre' },
          component: () => import('./views/Outros/Sobre.vue')
        },
        {
          path: '/sintegra',
          name: 'Sintegra',
          meta: { title: 'Sintegra' },
          component: () => import('./views/Outros/Sintegra/Sintegra.vue')
        },
        {
          path: '/grupo-acesso',
          name: 'GrupoAcesso',
          meta: { title: 'Grupo de Acesso' },
          component: () => import('./views/Configuracoes/grupo_acesso/GrupoAcesso.vue')
        },
        {
          path: '/tema',
          name: 'Tema',
          meta: { title: 'Tema' },
          component: () => import('./views/Configuracoes/Tema/Tema.vue')
        },
        //RELATORIOS
        {
          path: '/resumo-gerencial',
          name: 'ResumoGerencial',
          meta: { title: 'Resumo Gerencial' },
          component: () => import('./views/Relatorios/ResumoGerencial.vue')
        },
        {
          path: '/registro-inventario',
          name: 'RegistroInventario',
          meta: { title: 'Registro Inventário' },
          component: () => import('./views/Relatorios/RegistroInventario.vue')
        }
      ]
    },
    //IFRAME
    {
      path: '/participante_cadastrar',
      name: 'Participante_Cadastrar',
      meta: { title: 'Cadastrar Participante' },
      component: () => import('./views/Cadastros/participante/CadastrarParticipante.vue')
    },
    //404
    {
      path: '*',
      name: '404',
      component: () => import('./views/404.vue'),
      meta: { title: 'Página não encontrada' }
    },
    {
      path: '/vendas',
      name: 'VendaSimples',
      meta: { title: 'Vendas Simples' },
      component: () => import('./views/Movimentacao/venda_simples/VendaSimples.vue')
    }
  ]
});


router.beforeEach((to, from, next) => {
  document.title = to.meta?.title
    ? `${to.meta.title} - Web Casa Santos`
    : 'Web Casa Santos'
  next()
});

export default router
